import { render, staticRenderFns } from "./EmployerSupport.vue?vue&type=template&id=61a283ba&scoped=true"
import script from "./EmployerSupport.vue?vue&type=script&lang=ts"
export * from "./EmployerSupport.vue?vue&type=script&lang=ts"
import style0 from "./EmployerSupport.vue?vue&type=style&index=0&id=61a283ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a283ba",
  null
  
)

export default component.exports